import React from "react";

interface CopyIconProps {
  width?: number;
  height?: number;
  className?: string;
  fill?: string;
}

export const CopyIcon: React.FC<CopyIconProps> = ({
  width = 16,
  height = 16,
  className = "",
  fill = "currentColor",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.09998 10.2001C1.09998 11.0285 1.77155 11.7001 2.59998 11.7001H4.26664V10.7001H2.59998C2.32383 10.7001 2.09998 10.4762 2.09998 10.2001L2.09998 2.6001C2.09998 2.32396 2.32383 2.1001 2.59998 2.1001L10.2 2.1001C10.4761 2.1001 10.7 2.32395 10.7 2.6001V4.26676H11.7V2.6001C11.7 1.77167 11.0284 1.1001 10.2 1.1001L2.59998 1.1001C1.77155 1.1001 1.09998 1.77167 1.09998 2.6001L1.09998 10.2001ZM5.79998 4.30006C4.97155 4.30006 4.29998 4.97163 4.29998 5.80005V13.4001C4.29998 14.2285 4.97155 14.9001 5.79998 14.9001H13.4C14.2284 14.9001 14.9 14.2285 14.9 13.4001V5.80006C14.9 4.97163 14.2284 4.30006 13.4 4.30006H5.79998ZM5.29998 5.80005C5.29998 5.52391 5.52384 5.30006 5.79998 5.30006H13.4C13.6761 5.30006 13.9 5.52391 13.9 5.80006V13.4001C13.9 13.6762 13.6761 13.9001 13.4 13.9001H5.79998C5.52384 13.9001 5.29998 13.6762 5.29998 13.4001V5.80005Z"
      />
    </svg>
  );
};
